// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@awc/XDL/types";

export default {
    keys: ["xs", "sm", "md", "lg", "xl"],
    values: [0, 481, 768, 1025, 1440],
    maxWidths: [480, 768, 1024, 1440, 1440],
    paddingValues: [8, 8, 16, 16, 33],
} as xBaseTheme["breakpoints"];
